/**
 * Lib version constant — kept in sync with `package.json`. Used by the
 * `data-norkron-lib` stamp so the conformance walker can detect dual-realm
 * loads (CF_LIB_VERSION_DRIFT).
 *
 * @example
 * ```ts
 * import { LIB_VERSION } from '@norkron/web-offline-store'
 * console.log(`@norkron/web-offline-store v${LIB_VERSION}`)
 * ```
 */
export const LIB_VERSION = '0.2.0'
